import { render, staticRenderFns } from "./titleText.vue?vue&type=template&id=2df0276e&scoped=true"
import script from "./titleText.vue?vue&type=script&lang=js"
export * from "./titleText.vue?vue&type=script&lang=js"
import style0 from "./titleText.vue?vue&type=style&index=0&id=2df0276e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df0276e",
  null
  
)

component.options.__file = "titleText.vue"
export default component.exports